module.exports = __webpack_public_path__ + "img/DSC07568-2.7d3ed2b8.jpg";